import React from "react";
import { MetaMaskProvider } from "metamask-react";
import { Switch, Route } from "react-router";
import { HashRouter } from "react-router-dom";

import { isElectronApp } from "../../../helpers/Utils";
import MarketPage from "./MarketPage";
import MarketLoginPage from "./account/MarketLoginPage";
import MarketRegisterPage from "./account/MarketRegisterPage";
import MarketGenerateKey from "./account/register/MarketGenerateKey";
import MarketChooseKey from "./account/register/MarketChooseKey";
import MarketListingDetails from "./details/ListingDetails";
import ListingDraft from "./draft/ListingDraft";

import ContextNavComponent from "../../../components/ContextNavComponent/ContextNavComponent";
import MarketLogin from "./MarketLogin/MarketLogin";

export default function MarketPageIndex() {
	const path ="market";

	return (
		<HashRouter>
			<MetaMaskProvider>
				<ContextNavComponent>
					<Switch>
						<Route path={`/${path}/login/index`} exact component={MarketLogin} />
						<Route path={`/${path}/login`} exact component={MarketLoginPage} />
						<Route path={`/${path}/register`} exact component={MarketRegisterPage} />
						<Route path={`/${path}/register/generate`} exact component={MarketGenerateKey} />
						<Route path={`/${path}/register/choose`} exact component={MarketChooseKey} />

						<Route path={`/${path}/details/:id`} exact component={MarketListingDetails} />

						{/* Preview listing before publishing */}
						<Route exact path={`/${path}/preview`} component={ListingDraft} />

						<Route path={`/${path}`} component={MarketPage} />
					</Switch>
				</ContextNavComponent>
			</MetaMaskProvider>
		</HashRouter>
	);
}
